import { IEvent } from "@Interfaces";
import { isInstallmentsPlanType } from "repoV2/utils/common/listing";

/**
 * Evaluates whether to hide the discount code field on event page based on the provided event data, merchandise variant information, and flag indicating the presence of variants.
 * @returns {boolean} true if the discount should be hidden, otherwise false.
 */
export const evaluateHideDiscount = ({
    eventData,
    hasVariants,
    selectedVariant,
}: {
    hasVariants: boolean;
    selectedVariant?: IEvent.IVariant;
    eventData: IEvent.IEventData;
}) => {
    if (eventData?.metadata?.hide_discount) return true;

    // show in installments plan offering
    if (isInstallmentsPlanType(eventData.payment_plan_type)) return false;

    // hide if:
    // 1. for merchandise offering, if selected variant price is 0
    // 2. eventData?.metadata?.hide_discount flag is true
    if (
        (hasVariants && selectedVariant?.updated_price === 0) || // for merchandise offering
        eventData.updated_price === 0
    )
        return true;

    return false;
};
